import { getNestedValue } from "./helper";

export function sortDataWithContext(data, sortConfig) {
    if (!sortConfig.key) return data;

    const sorted = [...data].sort((a, b) => {
        const valueA = getNestedValue(a, sortConfig.key);
        const valueB = getNestedValue(b, sortConfig.key);

        if (valueA < valueB) return sortConfig.direction === "asc" ? -1 : 1;
        if (valueA > valueB) return sortConfig.direction === "asc" ? 1 : -1;
        return 0;
    });

    return sorted;
};

export function paginatedData(data, paginationConfig) {
    if (data.length < paginationConfig.limit) return data;

    return [...data].slice((paginationConfig.page - 1) * paginationConfig.limit, paginationConfig.page * paginationConfig.limit);
};

export const getColumnByType = {
  TEXT: "text",
  AMOUNT: "amount",
  STATUS: "status",
  DATE: "date",
  DATETIME: "datetime",
  BUTTON: "button",
  NUMBER: "number",
  PERCENT: "percent",
};
